var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{attrs:{"items":_vm.navbarItems,"fonticon":_vm.pageIcon,"navbartitle":_vm.pageTitle,"navbardescription":_vm.pageDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }